var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gap"},[_c('a-row',[_c('a-col',{style:({height: _vm.md+'px'}),attrs:{"xs":0,"sm":0,"md":24}}),_c('a-col',{style:({height: _vm.sm+'px'}),attrs:{"xs":0,"sm":24,"md":0}}),_c('a-col',{style:({height: _vm.xs+'px'}),attrs:{"xs":24,"sm":0,"md":0}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }